// NetScouters OTT - Test IDs centralizados (Fase 00 + 01)
export const HEADER = {
  brand: 'header-brand',
  nav: 'header-nav',
  eventsLink: 'header-events-link',
  clubsLink: 'header-clubs-link',
  loginLink: 'header-login-link',
  userMenuTrigger: 'header-user-menu',
  userMenuDashboard: 'header-user-menu-dashboard',
  userMenuAccount: 'header-user-menu-account',
  userMenuAdmin: 'header-user-menu-admin',
  userMenuLogout: 'header-user-menu-logout',
};

export const HERO = {
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  title: 'hero-title',
  tagline: 'hero-tagline',
  description: 'hero-description',
};

export const SPORTS = { chip: (slug) => `sport-chip-${slug}` };

export const VALUE_PROPS = {
  multideporte: 'value-prop-card-multideporte',
  directosHd: 'value-prop-card-directos-hd',
  clubStreaming: 'value-prop-card-club-streaming',
};

export const FOOTER = {
  brand: 'footer-brand',
  legalLink: 'footer-legal-link',
  privacyLink: 'footer-privacy-link',
  cookiesLink: 'footer-cookies-link',
};

export const PLACEHOLDER = {
  backHome: 'placeholder-back-home',
  notifyCta: 'placeholder-notify-cta',
};

export const AUTH = {
  // Login
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginRemember: 'login-remember',
  loginSubmit: 'login-submit',
  loginRegisterLink: 'login-register-link',
  loginForgotLink: 'login-forgot-link',
  loginError: 'login-error',
  // Register
  registerFirstName: 'register-first-name',
  registerLastName: 'register-last-name',
  registerEmail: 'register-email',
  registerPassword: 'register-password',
  registerPasswordConfirmation: 'register-password-confirmation',
  registerDob: 'register-dob',
  registerProfileType: (slug) => `register-profile-type-${slug}`,
  registerFavoriteClub: 'register-favorite-club',
  registerPrivacy: 'register-privacy',
  registerTerms: 'register-terms',
  registerMarketing: 'register-marketing',
  registerGuardianName: 'register-guardian-name',
  registerGuardianEmail: 'register-guardian-email',
  registerGuardianConsent: 'register-guardian-consent',
  registerSubmit: 'register-submit',
  registerLoginLink: 'register-login-link',
  registerError: 'register-error',
  registerSuccess: 'register-success',
  // Forgot
  forgotEmail: 'forgot-email',
  forgotSubmit: 'forgot-submit',
  forgotMessage: 'forgot-message',
  // Reset
  resetPassword: 'reset-password',
  resetPasswordConfirmation: 'reset-password-confirmation',
  resetSubmit: 'reset-submit',
  resetMessage: 'reset-message',
  resetError: 'reset-error',
};

export const DASHBOARD = {
  greeting: 'dashboard-greeting',
  profileTypeCard: 'dashboard-profile-type',
  statusCard: 'dashboard-status',
  emailCard: 'dashboard-email',
  logoutButton: 'dashboard-logout',
  goAccountButton: 'dashboard-go-account',
  goAdminButton: 'dashboard-go-admin',
  // Fase 07 — Tabs + sections
  tabsList: 'dashboard-tabs-list',
  tab: (key) => `dashboard-tab-${key}`, // overview|profile|club|purchases|subscriptions|events|videos|lives|downloads|player
  panel: (key) => `dashboard-panel-${key}`,
  // Overview cards
  overviewSubscription: 'dashboard-overview-subscription',
  overviewFavoriteClub: 'dashboard-overview-favorite-club',
  overviewCountPurchases: 'dashboard-overview-count-purchases',
  overviewCountEvents: 'dashboard-overview-count-events',
  overviewCountVideos: 'dashboard-overview-count-videos',
  overviewCountDownloads: 'dashboard-overview-count-downloads',
  overviewQuickPurchases: 'dashboard-overview-quick-purchases',
  overviewQuickContents: 'dashboard-overview-quick-contents',
  // Profile tab
  profileFirstName: 'dashboard-profile-first-name',
  profileLastName: 'dashboard-profile-last-name',
  profileMarketing: 'dashboard-profile-marketing',
  profileSubmit: 'dashboard-profile-submit',
  // Cambio de contraseña (Fase 07 extra)
  profilePwdCurrent: 'dashboard-profile-pwd-current',
  profilePwdNew: 'dashboard-profile-pwd-new',
  profilePwdConfirm: 'dashboard-profile-pwd-confirm',
  profilePwdSubmit: 'dashboard-profile-pwd-submit',
  // Club tab
  clubChange: 'dashboard-club-change',
  clubLink: 'dashboard-club-link',
  clubEmpty: 'dashboard-club-empty',
  // Purchases tab
  purchasesEmpty: 'dashboard-purchases-empty',
  purchaseRow: (id) => `dashboard-purchase-row-${id}`,
  // Subscriptions tab
  subscriptionsEmpty: 'dashboard-subscriptions-empty',
  subscriptionRow: (id) => `dashboard-subscription-row-${id}`,
  subscriptionCancel: (id) => `dashboard-subscription-cancel-${id}`,
  // Events tab
  eventsEmpty: 'dashboard-events-empty',
  eventRow: (id) => `dashboard-event-row-${id}`,
  // Videos tab
  videosEmpty: 'dashboard-videos-empty',
  videoRow: (id) => `dashboard-video-row-${id}`,
  // Lives tab (placeholder)
  livesPlaceholder: 'dashboard-lives-placeholder',
  // Downloads tab
  downloadsEmpty: 'dashboard-downloads-empty',
  downloadRow: (id) => `dashboard-download-row-${id}`,
  downloadBtn: (id) => `dashboard-download-btn-${id}`,
  // Player profile tab
  playerEmpty: 'dashboard-player-empty',
  playerCard: 'dashboard-player-card',
  // Fase 08 — Form fields
  playerFirstName: 'dashboard-player-first-name',
  playerLastName: 'dashboard-player-last-name',
  playerGender: 'dashboard-player-gender',
  playerBirth: 'dashboard-player-birth',
  playerHeight: 'dashboard-player-height',
  playerWeight: 'dashboard-player-weight',
  playerSport: 'dashboard-player-sport',
  playerClub: 'dashboard-player-club',
  playerTeam: 'dashboard-player-team',
  playerPosition: 'dashboard-player-position',
  playerDominantSide: 'dashboard-player-dominant-side',
  playerBio: 'dashboard-player-bio',
  playerPhotoInput: 'dashboard-player-photo-input',
  playerPhotoDelete: 'dashboard-player-photo-delete',
  playerSubmit: 'dashboard-player-submit',
  playerPendingReview: 'dashboard-player-pending-review',
  playerSuggestionNotice: 'dashboard-player-suggestion-notice',
  playerPerformanceStats: 'dashboard-player-performance-stats',
  playerPerformanceHealth: 'dashboard-player-performance-health',
};

export const ACCOUNT = {
  firstName: 'account-first-name',
  lastName: 'account-last-name',
  favoriteClub: 'account-favorite-club',
  marketing: 'account-marketing',
  submit: 'account-submit',
  successMessage: 'account-success',
};

export const ADMIN = {
  // Dashboard
  totalUsersKpi: 'admin-kpi-total-users',
  activeUsersKpi: 'admin-kpi-active-users',
  pendingUsersKpi: 'admin-kpi-pending-users',
  suspendedUsersKpi: 'admin-kpi-suspended-users',
  // List
  usersTable: 'admin-users-table',
  userRow: (id) => `admin-user-row-${id}`,
  userRowOpen: (id) => `admin-user-row-open-${id}`,
  searchInput: 'admin-search-input',
  statusFilter: 'admin-status-filter',
  profileTypeFilter: 'admin-profile-filter',
  prevPage: 'admin-prev-page',
  nextPage: 'admin-next-page',
  // Detail
  detailEmail: 'admin-detail-email',
  detailStatusSelect: 'admin-detail-status-select',
  detailStatusSave: 'admin-detail-status-save',
  detailProfileSelect: 'admin-detail-profile-select',
  detailProfileSave: 'admin-detail-profile-save',
  // Fase 07 extra — cambio de contraseña por admin
  detailPwdNew: 'admin-detail-pwd-new',
  detailPwdConfirm: 'admin-detail-pwd-confirm',
  detailPwdSave: 'admin-detail-pwd-save',
  detailPwdConfirmDialog: 'admin-detail-pwd-confirm-dialog',
  detailPwdConfirmDialogYes: 'admin-detail-pwd-confirm-dialog-yes',
  detailBack: 'admin-detail-back',
  // Fase 02 read-only lists
  sportsTable: 'admin-sports-table',
  clubsTable: 'admin-clubs-table',
  teamsTable: 'admin-teams-table',
  clubRow: (slug) => `admin-club-row-${slug}`,
};

// ---------------------------- Fase 02: Clubes ----------------------------
export const CLUBS = {
  page: 'clubs-page',
  searchInput: 'clubs-search-input',
  searchClear: 'clubs-search-clear',
  sportFilter: 'clubs-sport-filter',
  countryFilter: 'clubs-country-filter',
  regionFilter: 'clubs-region-filter',
  provinceFilter: 'clubs-province-filter',
  cityFilter: 'clubs-city-filter',
  clearFilters: 'clubs-clear-filters',
  toggleFiltersMobile: 'clubs-toggle-filters-mobile',
  grid: 'clubs-grid',
  emptyState: 'clubs-empty-state',
  loadingSkeleton: 'clubs-loading-skeleton',
  card: (slug) => `club-card-${slug}`,
  cardCta: (slug) => `club-card-cta-${slug}`,
  pagination: 'clubs-pagination',
  // Detail
  detailPage: 'club-detail-page',
  detailHero: 'club-detail-hero',
  detailLogo: 'club-detail-logo',
  detailName: 'club-detail-name',
  detailLocation: 'club-detail-location',
  detailDescription: 'club-detail-description',
  detailFollowBtn: 'club-detail-follow-btn',
  detailFollowingBadge: 'club-detail-following-badge',
  detailLoginCta: 'club-detail-login-cta',
  detailTeamsSection: 'club-detail-teams',
  detailTeamItem: (id) => `club-detail-team-${id}`,
  detailSponsorsSection: 'club-detail-sponsors',
  detailSponsorItem: (id) => `club-detail-sponsor-${id}`,
  detailEventsEmpty: 'club-detail-events-empty',
  detailVideosEmpty: 'club-detail-videos-empty',
  detailLivesEmpty: 'club-detail-lives-empty',
};

// ---------------------------- Fase 03: Eventos ----------------------------
export const EVENTS = {
  page: 'events-page',
  searchInput: 'events-search-input',
  searchClear: 'events-search-clear',
  tab: (key) => `events-tab-${key}`, // all | upcoming | live | replays | past
  sportFilter: 'events-sport-filter',
  clubFilter: 'events-club-filter',
  countryFilter: 'events-country-filter',
  regionFilter: 'events-region-filter',
  provinceFilter: 'events-province-filter',
  cityFilter: 'events-city-filter',
  accessTypeFilter: 'events-access-type-filter',
  statusFilter: 'events-status-filter',
  clearFilters: 'events-clear-filters',
  toggleFiltersMobile: 'events-toggle-filters-mobile',
  grid: 'events-grid',
  emptyState: 'events-empty-state',
  loadingSkeleton: 'events-loading-skeleton',
  card: (slug) => `event-card-${slug}`,
  cardCta: (slug) => `event-card-cta-${slug}`,
  pagination: 'events-pagination',
  // Detail
  detailPage: 'event-detail-page',
  detailHero: 'event-detail-hero',
  detailTitle: 'event-detail-title',
  detailStatusBadge: 'event-detail-status-badge',
  detailAccessBadge: 'event-detail-access-badge',
  detailDate: 'event-detail-date',
  detailLocation: 'event-detail-location',
  detailClubLink: 'event-detail-club-link',
  detailTeamsBlock: 'event-detail-teams',
  detailDescription: 'event-detail-description',
  detailVideoPlaceholder: 'event-detail-video-placeholder',
  detailLivePlaceholder: 'event-detail-live-placeholder',
  detailReplayPlaceholder: 'event-detail-replay-placeholder',
};

